module.exports = __webpack_public_path__ + "img/head-1.e72ec3b9.png";